import React from 'react'
import SocialMediaItem from './SocialMediaItem'
import { SocialMediaItemProps, SocialMediaRowProps } from '~types'
import Heading from '../Heading/Heading'
import styles from './SocialMediaRow.module.scss'

const SocialMediaRow = ({ align = 'left', socialMediaRowHeadline = '', socialMediaRow }: SocialMediaRowProps) => {
  return (
    <>
      <div className={styles['social-icons']}>
        {socialMediaRowHeadline ? (
          <Heading level={6} justify={align}>
            {socialMediaRowHeadline}
          </Heading>
        ) : null}

        <ul className={styles[align === 'center' ? 'is-aligned-center' : '']}>
          {Array.isArray(socialMediaRow) &&
            socialMediaRow.map((row: SocialMediaItemProps, index: number) => {
              const { icon, platformName, url } = row || {}
              return (
                url &&
                icon && (
                  <li key={index}>
                    <SocialMediaItem icon={icon} platformName={platformName} url={url} />
                  </li>
                )
              )
            })}
        </ul>
      </div>
    </>
  )
}

export default SocialMediaRow
